import _classCallCheck from "/home/mvarble/dropbox/Dropbox/development/websites/matthew-varble-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/mvarble/dropbox/Dropbox/development/websites/matthew-varble-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/mvarble/dropbox/Dropbox/development/websites/matthew-varble-site/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/home/mvarble/dropbox/Dropbox/development/websites/matthew-varble-site/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/mvarble/dropbox/Dropbox/development/websites/matthew-varble-site/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _get from "/home/mvarble/dropbox/Dropbox/development/websites/matthew-varble-site/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "/home/mvarble/dropbox/Dropbox/development/websites/matthew-varble-site/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { LineSegmentsGeometry } from './LineSegmentsGeometry.js';

var LineGeometry = /*#__PURE__*/function (_LineSegmentsGeometry) {
  _inherits(LineGeometry, _LineSegmentsGeometry);

  var _super = _createSuper(LineGeometry);

  function LineGeometry() {
    var _thisSuper, _this;

    _classCallCheck(this, LineGeometry);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "type", 'LineGeometry');

    _defineProperty(_assertThisInitialized(_this), "isLineGeometry", true);

    _defineProperty(_assertThisInitialized(_this), "setColors", function (array) {
      // converts [ r1, g1, b1,  r2, g2, b2, ... ] to pairs format
      var length = array.length - 3;
      var colors = new Float32Array(2 * length);

      for (var i = 0; i < length; i += 3) {
        colors[2 * i] = array[i];
        colors[2 * i + 1] = array[i + 1];
        colors[2 * i + 2] = array[i + 2];
        colors[2 * i + 3] = array[i + 3];
        colors[2 * i + 4] = array[i + 4];
        colors[2 * i + 5] = array[i + 5];
      }

      _get((_thisSuper = _assertThisInitialized(_this), _getPrototypeOf(LineGeometry.prototype)), "setColors", _thisSuper).call(_thisSuper, colors);

      return _assertThisInitialized(_this);
    });

    _defineProperty(_assertThisInitialized(_this), "fromLine", function (line) {
      var geometry = line.geometry;

      if (geometry.isBufferGeometry) {
        _this.setPositions(Array.from(geometry.attributes.position.array)); // assumes non-indexed

      } // set colors, maybe


      return _assertThisInitialized(_this);
    });

    _defineProperty(_assertThisInitialized(_this), "copy", function () {
      // todo
      return _assertThisInitialized(_this);
    });

    return _this;
  }

  _createClass(LineGeometry, [{
    key: "setPositions",
    value: function setPositions(array) {
      // converts [ x1, y1, z1,  x2, y2, z2, ... ] to pairs format
      var length = array.length - 3;
      var points = new Float32Array(2 * length);

      for (var i = 0; i < length; i += 3) {
        points[2 * i] = array[i];
        points[2 * i + 1] = array[i + 1];
        points[2 * i + 2] = array[i + 2];
        points[2 * i + 3] = array[i + 3];
        points[2 * i + 4] = array[i + 4];
        points[2 * i + 5] = array[i + 5];
      }

      _get(_getPrototypeOf(LineGeometry.prototype), "setPositions", this).call(this, points);

      return this;
    }
  }]);

  return LineGeometry;
}(LineSegmentsGeometry);

export { LineGeometry };